import CryptoJS from 'crypto-js';
import { IOrder, IDiscountItem } from '../../../../types';
import { formatCurrencyToTwoDecimals } from '../../../utils';
import toCataLayerCart from './cart';
import { getCookie } from '../../../utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function toDataLayer(order: IOrder): Record<string, any> {
  if (!order || hasBeenTracked(order)) return {};

  setOrderCookie(order);

  let hashed_id: string = '';
  if (order.email) {
    hashed_id = CryptoJS.SHA256(order.email).toString(CryptoJS.enc.Hex);
  }

  let order_id_hashed: string = '';
  if (order.order_number) {
    order_id_hashed = CryptoJS.SHA256(
      `7[zcPn!28\\0{$0f%${order.order_number}`,
    ).toString(CryptoJS.enc.Hex);
  }

  const cartData = toCataLayerCart({
    total_amount: order.total_amount,
    total_quantity: order.line_items?.length,
    line_items: order.line_items,
  });

  return {
    hashed_id: hashed_id,

    ...cartData,

    orders_total: formatCurrencyToTwoDecimals(order.total_amount || 0),
    order_merchandise_total: formatCurrencyToTwoDecimals(
      order.total_amount || 0,
    ),
    order_grand_total: formatCurrencyToTwoDecimals(order.subtotal_amount || 0),
    order_shipping_amount: formatCurrencyToTwoDecimals(
      order.delivery_amount || 0,
    ),
    order_discount_amount: formatCurrencyToTwoDecimals(
      order.discount_total_amount || 0,
    ),
    order_tax_amount: formatCurrencyToTwoDecimals(order.tax_amount || 0),
    order_id: order.order_number,
    order_id_hashed: order_id_hashed,
    order_count: order.lineItems?.length || 0,
    order_delivery_type: order.shipping_method?.name,
    order_currency_code:
      order.transactions?.[0]?.full_response?.amount?.currency,
    order_payment_type: order.transactions?.[0]?.provider,
    credit_card_type: order.transactions?.[0]?.selected_credit_card_brand,

    order_promo_code:
      order.discount_items?.map(
        (discountItem: IDiscountItem) => discountItem.summary,
      ) || [],

    order_has_replenishment_item: 'TBD',
    order_store_collection: 'TBD',
    order_delivery_window: 'TBD',
    offers: 'TBD',
    manual_offers: 'TBD',
    manual_coupons: 'TBD',
    manual_offer_is_coupon: 'TBD',
  };
}

function hasBeenTracked(order: IOrder): boolean {
  const orderTimestamp = new Date(order.inserted_at).setHours(0, 0, 0, 0);
  const pastTimestamp = new Date().setHours(-60, 0, 0, 0); // 2.5 days ago

  // return if orderTimestamp is before pastTimestamp or if order has already been tracked
  return pastTimestamp >= orderTimestamp || hasOrderCookie(order);
}

function hasOrderCookie(order: IOrder): boolean {
  const orderId = order.order_number;
  if (!orderId) return false;

  const orderCookie = getCookie(`tid_${orderId}`);
  return !!orderCookie;
}

function setOrderCookie(order: IOrder): void {
  const orderId = order.order_number;
  if (!orderId) return;

  // Set cookie with 4 day max age
  document.cookie = `tid_${orderId}=1; max-age=345600;`;
}
